module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "book"
  }, [_c('div', {
    staticClass: "coverInfo"
  }, [_c('img', {
    staticClass: "coverImage",
    attrs: {
      "src": "//textcafe.co/books/23wQMq/tc-custom/9783965374935.jpg?1702956766848",
      "alt": "This image is the cover for the book Der leuchtende Schlüssel, Classics To Go"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "bookInfo"
  }, [_c('h1', {
    staticClass: "bookTitle heading font1"
  }, [_vm._v("Der leuchtende Schlüssel, Classics To Go\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "bookDescription body article font2"
  }), _c('p', [_vm._v("Horace Tom Tickler, der Ganove, war tot. Erschossen in einem fremden Auto, mitten in London, vor dem eleganten Gesandtschafts-Klub. »Wenn Sie wissen wollen, wer Tickler ermordet hat, erkundigen Sie sich bei Mr. Moran.« Das stand auf einer Karte, die an Chefinspektor Smith adressiert war. Der Inspektor hielt Mr. Moran schon immer für eine dunkle Persönlichkeit. (Amazon)")]), _vm._v(" "), _c('p')]), _vm._v(" "), _c('div', {
    staticClass: "authorInfo"
  }, [_c('h2', {
    staticClass: "authorName heading font1"
  }, [_vm._v("\n      Edgar Wallace\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "authorDescription body article"
  }, [_vm._v("Richard Horatio Edgar Wallace; * 1. April 1875 in Greenwich bei London; † 10. Februar 1932 in Hollywood, Kalifornien) war ein englischer Schriftsteller, Drehbuchautor, Regisseur, Journalist und Dramatiker. Er gehört zu den erfolgreichsten englischsprachigen Kriminalschriftstellern. (Wikipedia)")])]), _vm._v(" "), _c('div', {
    staticClass: "publisherInfo"
  }, [_c('h2', {
    staticClass: "publisherName heading font1"
  }, [_vm._v("\n    OTB ebook\n   ")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-638a3f51","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/home.vue
// module id = 51
// module chunks = 0